import { render, staticRenderFns } from "./IconEntry.vue?vue&type=template&id=68dc5e63&"
import script from "./IconEntry.vue?vue&type=script&lang=js&"
export * from "./IconEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports